import { useEffect, useMemo } from "react";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import getMetrics from "src/organization/pages/project/environment/metrics/api/getMetrics";
import { Poller } from "src/organization/pages/project/environment/metrics/utils/polling/poller";
import { MetricsPollType } from "src/organization/pages/project/environment/metrics/utils/polling/type";

import { httpMetricsQueryFields, httpMetricsQueryFilters } from "../config";
import { getMetricQuery } from "../helper";
import { HttpMetricsResponseType } from "../types";

const useHttpMetricsPoll = ({
  timeframe,
  onChange,
  onError,
  onLoadingChange,
  interval = 30
}: MetricsPollType<HttpMetricsResponseType[]>) => {
  const environment = useSelectorWithUrlParams(environmentSelector);
  const metricsLink = environment?.getLinks()?.["#metrics"]?.[0] as {
    collection?: string;
    href?: string;
  };

  const poller = useMemo(
    () => new Poller({ onChange, onError, onLoadingChange }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (metricsLink?.href && metricsLink.collection) {
      const collection = metricsLink?.collection;
      const href = metricsLink?.href;

      const fetchMetrics = () => {
        const query = getMetricQuery({
          collection,
          timeframe,
          fields: httpMetricsQueryFields,
          filters: httpMetricsQueryFilters,
          post_filters: [
            {
              name: "top",
              top: {
                n: 10,
                field: "request.url.method.impact",
                descending: true,
                consistent: true
              }
            }
          ]
        });
        return getMetrics<HttpMetricsResponseType>(href, query);
      };
      //time with Id does not have a start which makes It is suitable for continous polling
      timeframe.id
        ? poller.startPolling(fetchMetrics, interval)
        : poller.pollOnce(fetchMetrics);
    }
  }, [metricsLink?.href, metricsLink?.collection, timeframe, interval, poller]);

  useEffect(() => {
    return () => poller.stopPolling();
  }, [poller]);
  return poller;
};

export default useHttpMetricsPoll;
